import React, { useRef, useState, useEffect } from 'react';
import { Camera } from 'react-camera-pro';
import ConfirmComponent from './Confirm';
import { Buffer } from 'buffer';
import { useTranslation } from 'react-i18next';

function CameraComponent(props) {
    const { t } = useTranslation();
    const camera = useRef(null);
  
    const capturePhoto = async () => {
        const file = await camera.current.takePhoto(); 
        let blob = base64DataUrlToBlob(file);

        Object.assign(blob, {
            uri: file ? URL.createObjectURL(blob) : null,
            id: new Date().getTime(),
        })

        let timestamp = Math.floor(new Date().getTime() / 1000) + 600;

        let fileb = blobToFile(blob, timestamp + '.jpg');
        fileb.uri = blob.uri
        props.onCapture(fileb);
        };

        const blobToFile = (blob, fileName) => {
            return new File([blob], fileName, {
                uri: blob.uri,
                type: 'image/png'
            });
        };

        const base64DataUrlToBlob = (dataUrl) => {
        const [meta, base64Data] = dataUrl.split(',');
        const mimeMatch = meta.match(/data:(.*?);base64/);
        const mime = mimeMatch ? mimeMatch[1] : 'application/octet-stream';

        const byteArray = Buffer.from(base64Data, 'base64');
        return new Blob([byteArray], { type: mime });
    };

    return (
        <>
            {/* <ConfirmComponent isOpen={true} enableCloseButton={true}
                title={t('take_a_photo')}
                otherMessage={
                    <Camera
                    ref={camera}
                    aspectRatio={9 / 16}
                    facingMode="environment"
                    errorMessages={{
                        noCameraAccessible: t('noCameraAccessible'),
                        permissionDenied: t('permissionDenied'),
                        switchCamera: t('switchCamera'),
                    }}
                />}
                onClose={() => {props.setShowCamera(false)}}
                onAction={() => {
                    capturePhoto();
                    props.setShowCamera(false)}}                    
            /> */}

                <Camera
                ref={camera}
                aspectRatio={9 / 16}
                facingMode="environment"
                errorMessages={{
                    noCameraAccessible: t('noCameraAccessible'),
                    permissionDenied: t('permissionDenied'),
                    switchCamera: t('switchCamera'),
                }}
            />
        </>
    );
}

export default CameraComponent;
